<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <app-upsert
        :config="config"
        :item="patch"
        @saved="saved"/>

    </v-flex>

  </v-container>
</template>

<script>

import config from './config_new.js'

export default {
  data ({ $store, $route }) {
    const query = $route && $route.query
    let patch = {}

    if (query && query.protocol_id) {
      patch.protocol_id = Number(query.protocol_id)
      patch.entity = query.entity
      patch.entity_id = query.entity_id
    } else if ($store.getters.app.protocol.id !== -1) {
      patch.protocol_id = $store.getters.app.protocol.id
    }
    return {
      config,
      patch
    }
  },
  methods: {
    saved ({ data }) {
      this.$router.push(`/patch/${data.id}`)
    }
  }
}
</script>